import React from "react";
import { recoverTag, getAlarmTimeText } from "bodycodi/cmap/app/js/common";
import icon_alarm_schedule from "bodycodi/cmap/app/svg/icon_alarm_schedule.svg";
import icon_alarm_schedule_cancel from "bodycodi/cmap/app/svg/icon_alarm_schedule_cancel.svg";
import icon_alarm_community from "bodycodi/cmap/app/svg/icon_alarm_community.svg";
import icon_alarm_member from "bodycodi/cmap/app/svg/icon_alarm_member.svg";
import icon_alarm_etc from "bodycodi/cmap/app/svg/icon_alarm_etc.svg";
import icon_alarm_schedule_close from "bodycodi/cmap/app/svg/icon_alarm_schedule_close.svg";

interface Alram {
  message: any;
}

const ALARM_TYPE: { [key: string]: string } = {
  SCHEDULE_RESERVATION: icon_alarm_schedule,
  SCHEDULE_CANCEL: icon_alarm_schedule_cancel,
  COMMUNITY: icon_alarm_community,
  MEMBER: icon_alarm_member,
  UNSPECIFIED: icon_alarm_etc,
  SCHEDULE_CLOSE: icon_alarm_schedule_close,
};

function Alram({ message }: Alram) {
  return (
    <div className={"message-wrap" + (message.readFlag ? "" : " blue")}>
      <div className="icon">
        <img src={ALARM_TYPE[message.alarmTypeCode]} />
      </div>
      <div className="message">
        <div className="partner-name">
          {message.partnerName} {message.partnerBranchName}
        </div>
        <div className="title">{message.title}</div>
        <div className="decs">{recoverTag(message.message)}</div>
        <div className="date">{getAlarmTimeText(message.sendDt)}</div>
      </div>
    </div>
  );
}

export default Alram;
